import { BillPayCta } from './bill-pay-cta.component';

export { BillPayCta };
